import React from "react";
import Button from "@/ui/Button/Button";
import { useAdminPriceEdaContext } from "./context";
import cls from "./styles.module.scss";

export const EditorCopyBar = () => {
  const {
    editor: { copyCarToVelo, copySaving, saving, zoneSaving, pendingCount },
  } = useAdminPriceEdaContext();

  return (
    <div className={cls.sidebarSection}>
      <div className={cls.sidebarLabel}>Синхронизация</div>
      <Button
        type="button"
        label="Копировать цены авто в вело"
        variant="outlined"
        onClick={copyCarToVelo}
        loading={copySaving}
        disabled={saving || zoneSaving || Boolean(pendingCount)}
        className={cls.copyButton}
      />
    </div>
  );
};
